/** 当前 URL 是否为 history 路由模式（hash 模式 URL 含 #/） */
export function isHistoryModeVersion() {
  return !/#\/.*/.test(window.location.href)
}

/**
 * 兼容旧 hash 链接与新 history 链接（须在 VueRouter 实例化前调用）
 * - history 模式：/#/path?x=1 → /path?x=1
 * - hash 模式：/path?x=1 → /#/path?x=1
 */
export function migrateRouteUrl(isHistoryMode) {
  const { pathname, search, hash } = window.location
  const normalizedPath = pathname.replace(/\/index\.html$/, '') || '/'

  if (isHistoryMode) {
    if (hash && /^#\/.+/.test(hash)) {
      history.replaceState(null, '', `${normalizedPath === '/' ? '' : normalizedPath}${hash.slice(1)}`)
    }
    return
  }

  if (normalizedPath !== '/' && (!hash || hash === '#')) {
    window.location.replace(`${window.location.origin}/#${normalizedPath}${search}`)
  }
}
